import { parseApiDate } from "./date";

export const RICHIESTA_EXPIRY_HOURS = 24;
const RICHIESTA_EXPIRY_MS = RICHIESTA_EXPIRY_HOURS * 60 * 60 * 1000;

const OFFER_ACCEPTED_STATES = new Set(["SELEZIONATA", "ACCETTATA"]);
const PROCESS_STARTED_STATES = new Set([
  "IN_ATTESA_PAGAMENTO",
  "OFFERTA_ACCETTATA",
  "DA_PAGARE",
  "PAGATA",
  "IN_LAVORAZIONE",
  "PRONTA",
  "CONSEGNATA",
  "COMPLETATA",
]);

export const hasAcceptedOffer = (richiesta) => {
  if (!richiesta) {
    return false;
  }

  const acceptedOfferId = richiesta.offertaAccettataId || null;
  const offerte = Array.isArray(richiesta.offerte) ? richiesta.offerte : [];

  if (acceptedOfferId) {
    return offerte.some((offerta) => {
      const offerId = offerta?.id || offerta?.sellerId || null;
      return offerId === acceptedOfferId;
    });
  }

  return offerte.some((offerta) => OFFER_ACCEPTED_STATES.has(offerta?.stato));
};

export const hasStartedProcess = (richiesta) => {
  if (!richiesta) {
    return false;
  }

  if (hasAcceptedOffer(richiesta)) {
    return true;
  }

  return PROCESS_STARTED_STATES.has(richiesta?.stato);
};

export const getRichiestaExpiresAt = (richiesta) => {
  const explicitExpiry = parseApiDate(richiesta?.expiresAt);
  if (explicitExpiry && !Number.isNaN(explicitExpiry.getTime())) {
    return explicitExpiry;
  }

  const createdAt = parseApiDate(richiesta?.createdAt);
  if (!createdAt || Number.isNaN(createdAt.getTime())) {
    return null;
  }

  return new Date(createdAt.getTime() + RICHIESTA_EXPIRY_MS);
};

export const isRichiestaExpired = (richiesta, now = new Date()) => {
  if (hasStartedProcess(richiesta)) {
    return false;
  }

  const expiresAt = getRichiestaExpiresAt(richiesta);
  if (!expiresAt) {
    return false;
  }

  return now.getTime() > expiresAt.getTime();
};
